// ScheduleStatistics.jsx
import React from "react";
import "./ScheduleStatistics.css";

const ScheduleStatistics = ({ statistics, loading = false }) => {
  if (loading) {
    return (
      <div className="schedule-statistics">
        <div className="row g-3">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="col-xl col-lg-4 col-md-6">
              <div className="stat-card">
                <div className="stat-card-body">
                  <div
                    className="skeleton-loader"
                    style={{ height: "60px" }}
                  ></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!statistics) return null;

  const stats = statistics.statistics;

  return (
    <div className="schedule-statistics">
      <div className="row g-3">
        {/* إجمالي الجداول */}
        <div className="col-xl col-lg-4 col-md-6">
          <div className="stat-card stat-card-primary">
            <div className="stat-card-body">
              <div className="stat-icon">
                <i className="fas fa-calendar-alt"></i>
              </div>
              <div className="stat-content">
                <p className="stat-title">{stats.total.label}</p>
                <h3 className="stat-value">{stats.total.count}</h3>
              </div>
            </div>
            <div
              className="stat-card-footer"
              style={{ borderTopColor: "var(--primary-100)" }}
            >
              <small className="text-muted">{stats.total.percentage}%</small>
            </div>
          </div>
        </div>

        {/* قيد الانتظار */}
        <div className="col-xl col-lg-4 col-md-6">
          <div className="stat-card stat-card-warning">
            <div className="stat-card-body">
              <div className="stat-icon">
                <i className="fas fa-clock"></i>
              </div>
              <div className="stat-content">
                <p className="stat-title">{stats.pending.label}</p>
                <h3 className="stat-value">{stats.pending.count}</h3>
              </div>
            </div>
            <div
              className="stat-card-footer"
              style={{ borderTopColor: "#ffc107" }}
            >
              <small className="text-muted">{stats.pending.percentage}%</small>
            </div>
          </div>
        </div>

        {/* جاري التنفيذ */}
        <div className="col-xl col-lg-4 col-md-6">
          <div className="stat-card stat-card-info">
            <div className="stat-card-body">
              <div className="stat-icon">
                <i className="fas fa-spinner"></i>
              </div>
              <div className="stat-content">
                <p className="stat-title">{stats.in_progress.label}</p>
                <h3 className="stat-value">{stats.in_progress.count}</h3>
              </div>
            </div>
            <div
              className="stat-card-footer"
              style={{ borderTopColor: "#17a2b8" }}
            >
              <small className="text-muted">
                {stats.in_progress.percentage}%
              </small>
            </div>
          </div>
        </div>

        {/* مكتملة */}
        <div className="col-xl col-lg-4 col-md-6">
          <div className="stat-card stat-card-success">
            <div className="stat-card-body">
              <div className="stat-icon">
                <i className="fas fa-check-circle"></i>
              </div>
              <div className="stat-content">
                <p className="stat-title">{stats.completed.label}</p>
                <h3 className="stat-value">{stats.completed.count}</h3>
              </div>
            </div>
            <div
              className="stat-card-footer"
              style={{ borderTopColor: "#28a745" }}
            >
              <small className="text-muted">
                {stats.completed.percentage}%
              </small>
            </div>
          </div>
        </div>

        {/* متأخرة */}
        <div className="col-xl col-lg-4 col-md-6">
          <div className="stat-card stat-card-danger">
            <div className="stat-card-body">
              <div className="stat-icon">
                <i className="fas fa-exclamation-triangle"></i>
              </div>
              <div className="stat-content">
                <p className="stat-title">{stats.overdue.label}</p>
                <h3 className="stat-value">{stats.overdue.count}</h3>
              </div>
            </div>
            <div
              className="stat-card-footer"
              style={{ borderTopColor: "#dc3545" }}
            >
              <small className="text-muted">{stats.overdue.percentage}%</small>
            </div>
          </div>
        </div>
      </div>

      {/* نسبة الإكمال */}
      {statistics.completionRate > 0 && (
        <div className="completion-progress-section mt-4">
          <h6 className="mb-3">نسبة الإكمال الإجمالية</h6>
          <div className="progress" style={{ height: "30px" }}>
            <div
              className="progress-bar bg-success"
              role="progressbar"
              style={{ width: `${statistics.completionRate}%` }}
              aria-valuenow={statistics.completionRate}
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {statistics.completionRate}%
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScheduleStatistics;
